import React from 'react';
import {
  Building2,
  CheckCircle2,
  FileText,
  MessageSquare,
  PlusCircle,
  List,
  Mail
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface DashboardOverviewProps {
  isVerified: boolean;
  landlordName: string;
  totalListings: number;
  activeListings: number;
  pendingInquiries: number;
  draftListings?: number;
}

const DashboardOverview: React.FC<DashboardOverviewProps> = ({
  isVerified,
  landlordName,
  totalListings,
  activeListings,
  pendingInquiries,
  draftListings = 0
}) => {
  const navigate = useNavigate();
  const greetingPrefix = 'Welcome back';
  const userGreeting = landlordName.length
    ? `${greetingPrefix}, ${landlordName}!`
    : greetingPrefix;
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 md:p-8 rounded-xl shadow-lg">
      <h2 className="text-2xl md:text-3xl font-extrabold mb-6 text-gray-800">
        {userGreeting}
      </h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8">
        {/* Total Listings Card */}
        <div className="bg-white p-4 md:p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
          <div className="flex flex-col items-center text-center">
            <div className="bg-blue-100 p-3 rounded-full mb-3">
              <Building2 className="w-8 h-8 md:w-10 md:h-10 text-blue-600" />
            </div>
            <h3 className="text-sm md:text-base font-semibold text-gray-600 mb-2">
              Total Listings
            </h3>
            <p className="text-3xl md:text-4xl font-bold text-gray-900">
              {totalListings}
            </p>
          </div>
        </div>
        {/* Active Listings Card */}
        <div className="bg-white p-4 md:p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
          <div className="flex flex-col items-center text-center">
            <div className="bg-green-100 p-3 rounded-full mb-3">
              <CheckCircle2 className="w-8 h-8 md:w-10 md:h-10 text-green-600" />
            </div>
            <h3 className="text-sm md:text-base font-semibold text-gray-600 mb-2">
              Active Listings
            </h3>
            <p className="text-3xl md:text-4xl font-bold text-gray-900">
              {activeListings}
            </p>
          </div>
        </div>
        {/* Draft Listings Card */}
        <div className="bg-white p-4 md:p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
          <div className="flex flex-col items-center text-center">
            <div className="bg-gray-100 p-3 rounded-full mb-3">
              <FileText className="w-8 h-8 md:w-10 md:h-10 text-gray-600" />
            </div>
            <h3 className="text-sm md:text-base font-semibold text-gray-600 mb-2">
              Draft Listings
            </h3>
            <p className="text-3xl md:text-4xl font-bold text-gray-900">
              {draftListings}
            </p>
          </div>
        </div>
        {/* Pending Inquiries Card */}
        <div className="bg-white p-4 md:p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
          <div className="flex flex-col items-center text-center">
            <div className="bg-yellow-100 p-3 rounded-full mb-3">
              <MessageSquare className="w-8 h-8 md:w-10 md:h-10 text-yellow-600" />
            </div>
            <h3 className="text-sm md:text-base font-semibold text-gray-600 mb-2">
              Pending Inquiries
            </h3>
            <p className="text-3xl md:text-4xl font-bold text-gray-900">
              {pendingInquiries}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap gap-4 mt-8">
        {/* {!isVerified &&
          (remoteConfig.requireIdentityVerification() ||
            remoteConfig.requireEmailVerificationToCreateListing()) && (
            <>
              <p>
                You need to complete email or identity verification before you
                can create listings
              </p>
            </>
          )} */}

        <>
          <button
            onClick={() => navigate('/add-listing')}
            className="flex items-center bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-6 py-3 rounded-lg hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
          >
            <PlusCircle className="w-5 h-5 mr-2" />
            Add New Listing
          </button>
          <button
            onClick={() => navigate('/my-listings')}
            className="flex items-center bg-gradient-to-r from-green-500 to-teal-500 text-white px-6 py-3 rounded-lg hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
          >
            <List className="w-5 h-5 mr-2" />
            View All Listings
          </button>
          <button
            onClick={() => navigate('/messages')}
            className="flex items-center bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-6 py-3 rounded-lg hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
          >
            <Mail className="w-5 h-5 mr-2" />
            Check Messages
          </button>
        </>
        {/* {isVerified && remoteConfig.requireEmailVerificationToCreateListing() && (
          <>
            <button
              onClick={() => navigate('/add-listing')}
              className="flex items-center bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-6 py-3 rounded-lg hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
            >
              <PlusCircleIcon className="w-6 h-6 mr-2" />
              Add New Listing
            </button>
            <button
              onClick={() => navigate('/my-listings')}
              className="flex items-center bg-gradient-to-r from-green-500 to-teal-500 text-white px-6 py-3 rounded-lg hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
            >
              <ListBulletIcon className="w-6 h-6 mr-2" />
              View All Listings
            </button>
            <button
              onClick={() => navigate('/messages')}
              className="flex items-center bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-6 py-3 rounded-lg hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
            >
              <EnvelopeIcon className="w-6 h-6 mr-2" />
              Check Messages
            </button>
          </>
        )} */}
      </div>
    </div>
  );
};

export default DashboardOverview;
